export const setTokenToLocalStorage = (token) => {
  window.localStorage.setItem("Token", token);
};

export const getTokenToLocalStorage = (): string => {
  return window.localStorage.getItem("Token");
};

export const clearToken = () => {
  window.localStorage.removeItem("Token");
};


export const setUserName = (name) => {
  window.localStorage.setItem("UserName", name);
};

export const getUserName = (): string => {
  return window.localStorage.getItem("UserName");
};

export const clearUserName = () => {
  window.localStorage.removeItem("UserName");
};
